import { Platform } from '@modules/test-development/enums/platform.enum';
import { Icon, ToolTip } from '@testsigma/atoms';
import classNames from 'classnames';

interface LabOSTypeProps {
  osType: Platform;
  osVersion: string;
  className?: string;
  variant?: 'detail' | 'concise';
}

const labOSIconMapping = {
  [Platform.Windows]: 'windows',
  [Platform.Mac]: 'ios',
  [Platform.Linux]: 'linux',
  [Platform.iOS]: 'ios',
  [Platform.Android]: 'android',
};

export const LabOSType: React.FC<LabOSTypeProps> = ({
  osType,
  osVersion,
  className,
  variant = 'concise',
}) => {
  const formattedOsVersion = isNaN(parseInt(osVersion + ''))
    ? osVersion
    : 'V.' + osVersion;

  return (
    <ToolTip
      content={`${osType} ${formattedOsVersion}`}
      placement='top'
      align='center'
    >
      <span className={classNames('flex flex-row items-center', className)}>
        <Icon
          name={labOSIconMapping[osType]}
          className='text-secondary-400 group-hover:text-secondary-unique-800 hover:text-secondary-unique-800 text-base'
        />
        {variant === 'detail' && (
          <span className='ml-2 truncate'>{formattedOsVersion}</span>
        )}
      </span>
    </ToolTip>
  );
};
